<template>
  <div class="home-shell">
    <button
      class="btn-toggle-sidebar"
      :class="{ fechada: sidebarFechada }"
      :style="{ left: sidebarFechada ? '10px' : (sidebarWidth + 6) + 'px' }"
      @click="alternarSidebar"
    >
      <i class="bi" :class="sidebarFechada ? 'bi-list' : 'bi-chevron-left'"></i>
    </button>

    <div
      class="sidebar-wrap"
      :class="{ fechada: sidebarFechada, redimensionando: redimensionando }"
      :style="{
        width: sidebarWidth + 'px',
        minWidth: sidebarWidth + 'px',
        marginLeft: sidebarFechada ? (-sidebarWidth) + 'px' : '0px',
        opacity: sidebarFechada ? 0 : 1
      }"
    >
      <side-bar-component></side-bar-component>
      <div
        v-if="!sidebarFechada"
        class="sidebar-resize-handle"
        title="Arraste para redimensionar"
        @pointerdown="iniciarRedimensionamento"
      ></div>
    </div>

    <div class="conteudo-wrap">
      <hello-world />
    </div>

    <command-palette></command-palette>
    <horario-tooltip></horario-tooltip>
    <tutorial-modal></tutorial-modal>
  </div>
</template>

<script>
/* eslint-disable */
import HelloWorld from '../components/HelloWorld'
import SideBarComponent from '../components/SideBarComponent';
import CommandPalette from '../components/CommandPalette.vue';
import HorarioTooltip from '../components/HorarioTooltip.vue';
import TutorialModal from '../components/TutorialModal.vue';

const SIDEBAR_LARGURA_PADRAO = 280
const SIDEBAR_LARGURA_MINIMA = 220
const SIDEBAR_LARGURA_MAXIMA = 480
const SIDEBAR_STORAGE_KEY = 'sidebar_largura'

export default {
  name: 'Home',

  components: {
    HelloWorld,
    SideBarComponent,
    CommandPalette,
    HorarioTooltip,
    TutorialModal
  },
  data() {
    return {
      sidebarFechada: false,
      sidebarWidth: SIDEBAR_LARGURA_PADRAO,
      redimensionando: false,
      larguraInicial: 0,
      xInicial: 0
    }
  },
  methods: {
    alternarSidebar() {
      this.sidebarFechada = !this.sidebarFechada
    },
    iniciarRedimensionamento(event) {
      if (this.sidebarFechada) return

      event.preventDefault()
      this.redimensionando = true
      this.larguraInicial = this.sidebarWidth
      this.xInicial = event.clientX

      document.addEventListener('pointermove', this.redimensionar)
      document.addEventListener('pointerup', this.finalizarRedimensionamento)
      document.body.style.cursor = 'col-resize'
      document.body.style.userSelect = 'none'
    },
    redimensionar(event) {
      if (!this.redimensionando) return

      const delta = event.clientX - this.xInicial
      const novaLargura = this.larguraInicial + delta

      this.sidebarWidth = Math.min(Math.max(novaLargura, SIDEBAR_LARGURA_MINIMA), SIDEBAR_LARGURA_MAXIMA)
    },
    finalizarRedimensionamento() {
      if (!this.redimensionando) return

      this.redimensionando = false
      document.removeEventListener('pointermove', this.redimensionar)
      document.removeEventListener('pointerup', this.finalizarRedimensionamento)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''

      try {
        localStorage.setItem(SIDEBAR_STORAGE_KEY, String(this.sidebarWidth))
      } catch (e) {
        // localStorage indisponível (ex: modo privado) - ignora
      }
    }
  },
  created() {
    try {
      const larguraSalva = parseInt(localStorage.getItem(SIDEBAR_STORAGE_KEY), 10)
      if (!isNaN(larguraSalva)) {
        this.sidebarWidth = Math.min(Math.max(larguraSalva, SIDEBAR_LARGURA_MINIMA), SIDEBAR_LARGURA_MAXIMA)
      }
    } catch (e) {
      // localStorage indisponível (ex: modo privado) - mantém o padrão
    }
  },
  beforeDestroy() {
    document.removeEventListener('pointermove', this.redimensionar)
    document.removeEventListener('pointerup', this.finalizarRedimensionamento)
  }
}
</script>
<style scoped>
.home-shell {
  display: flex;
  height: 100vh;
  width: 100%;
  background: var(--rd-bg-app);
  position: relative;
}

.sidebar-wrap {
  position: relative;
  transition: margin-left 0.25s ease, opacity 0.2s ease;
}

.sidebar-wrap.redimensionando {
  transition: none;
}

.sidebar-resize-handle {
  position: absolute;
  top: 0;
  right: -3px;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  z-index: 10;
  touch-action: none;
}

.sidebar-resize-handle:hover,
.sidebar-resize-handle:active {
  background: var(--rd-accent, var(--rd-border-strong));
  opacity: 0.5;
}

.conteudo-wrap {
  flex: 1;
  min-width: 0;
}

.btn-toggle-sidebar {
  position: absolute;
  top: 14px;
  z-index: 500;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid var(--rd-border-strong);
  background: var(--rd-bg-1);
  color: var(--rd-text-2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: left 0.25s ease;
}

.btn-toggle-sidebar:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}
</style>
